import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Users, Droplets, Building2, Award, FileCheck, ShieldAlert } from 'lucide-react';
import { Card, Skeleton, useIsMobile } from '../components/ui';
import AdminLayout from '../components/layout/AdminLayout';
import api from '../utils/api';

export default function AdminOverview() {
  const [stats, setStats] = useState(null);
  const [loadError, setLoadError] = useState(false);
  const isMobile = useIsMobile();

  useEffect(() => {
    api.get('/admin/overview')
      .then(r => setStats(r.data))
      .catch(() => setLoadError(true));
  }, []);

  const tiles = stats ? [
    { label: 'Donors', value: stats.total_donors, Icon: Droplets, color: 'var(--red)' },
    { label: 'Recipients', value: stats.total_recipients, Icon: Users, color: 'var(--blue-dark)' },
    { label: 'Organizations', value: stats.total_organizations, Icon: Building2, color: 'var(--green-dark)' },
    { label: 'Certificates issued', value: stats.certificates_issued, Icon: Award, color: 'var(--amber-dark)' },
    { label: 'Open requests', value: stats.open_requests, Icon: ShieldAlert, color: 'var(--red-dark)' },
    { label: 'Fulfilled requests', value: stats.fulfilled_requests, Icon: FileCheck, color: 'var(--green-dark)' },
  ] : [];

  return (
    <AdminLayout>
      <div style={{ marginBottom: '16px' }}>
        <h1 style={{ fontSize: '22px', fontWeight: 800, letterSpacing: '-0.03em', color: 'var(--gray-900)' }}>Admin Overview</h1>
        <p style={{ fontSize: '13.5px', color: 'var(--gray-500)', marginTop: '4px' }}>Platform activity at a glance.</p>
      </div>

      {loadError ? (
        <Card><p style={{ fontSize: '13.5px', color: 'var(--red)' }}>Couldn't load stats. Please try again.</p></Card>
      ) : !stats ? (
        <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(3,1fr)', gap: '12px' }}>
          {[0, 1, 2, 3, 4, 5].map(i => <Card key={i}><Skeleton height="46px" /></Card>)}
        </div>
      ) : (
        <>
          <div style={{ display: 'grid', gridTemplateColumns: isMobile ? 'repeat(2,1fr)' : 'repeat(3,1fr)', gap: '12px', marginBottom: '18px' }}>
            {tiles.map(t => (
              <Card key={t.label}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{
                    width: '38px', height: '38px', borderRadius: '10px', flexShrink: 0,
                    background: `${t.color}1a`, display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                    <t.Icon size={18} color={t.color} />
                  </div>
                  <div>
                    <div style={{ fontSize: '20px', fontWeight: 800, color: 'var(--gray-900)', letterSpacing: '-0.02em' }}>{t.value}</div>
                    <div style={{ fontSize: '12px', color: 'var(--gray-500)', fontWeight: 600 }}>{t.label}</div>
                  </div>
                </div>
              </Card>
            ))}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '12px' }}>
            <Link to="/admin/organizations" style={{ textDecoration: 'none' }}>
              <Card interactive style={{
                background: stats.pending_organization_verifications > 0 ? 'var(--amber-light)' : 'var(--gray-50)',
                border: `1px solid ${stats.pending_organization_verifications > 0 ? '#FDD07A' : 'var(--gray-100)'}`,
              }}>
                <div style={{ fontSize: '13.5px', fontWeight: 700, color: 'var(--gray-900)' }}>
                  {stats.pending_organization_verifications} organization{stats.pending_organization_verifications !== 1 ? 's' : ''} pending verification
                </div>
                <div style={{ fontSize: '12px', color: 'var(--gray-500)', marginTop: '3px' }}>Review and verify →</div>
              </Card>
            </Link>
          </div>
        </>
      )}
    </AdminLayout>
  );
}
